export const actionTypes = {
    loadMasterDataLoaded: "loadMasterDataLoaded",
    loadMasterDataFailedToLoad: "loadMasterDataFailedToLoad",
    startLoadingMaster: "startLoadingMaster",
    endLoadingMaster: "endLoadingMaster",
    startLoadingPage: "startLoadingPage",
    endLoadingPage: "endLoadingPage",
    homePageDataLoaded: "homePageDataLoaded",
    homePageDataFailedToLoad: "homePageDataFailedToLoad",
    aboutUsPageDataFailedToLoad: "aboutUsPageDataFailedToLoad",
    aboutUsPageDataLoaded: "aboutUsPageDataLoaded",
    servicesPageDataFailedToLoad: "servicesPageDataFailedToLoad",
    servicesPageDataLoaded: "servicesPageDataLoaded",
    contactsPageDataFailedToLoad: "contactsPageDataFailedToLoad",
    contactsPageDataLoaded: "contactsPageDataLoaded",
    setSubmittingRequest: "setSubmittingRequest",
    setSuccessMessages: "setSuccessMessages"

};

export const GlobalUrls = {
    API_BASE_URL: ""
}

export const ApiUrls = {
    LoadMasterPage: "api/masterpage",
    LoadHomePage: "api/homepage",
    AboutUsPage: "api/aboutuspage",
    ServicesPage: "api/servicespage",
    ContactsPage: "api/contactspage",
    SubmitRequest: "api/submitrequest"
}


// WEBPACK FOOTER //
// ./ClientApp/app/Constants/constants.tsx